<app-otp-general credType="sms" niceOtpName="Text"></app-otp-general>
